import { Collection } from 'modules/core/lib/mobx-rest'

import NineGridBox from 'modules/competencies/store/models/NineGridBox'

class NineGridBoxes extends Collection<NineGridBox> {
  get indexes() {
    return ['competency_id']
  }

  model() {
    return NineGridBox
  }

  getCompetency(competencyId: number) {
    return this.find({ competency_id: competencyId })
  }

  async customIndex<NineGridBox>({
    data,
  }: {
    data?: Record<string | symbol, unknown>
  }): Promise<NineGridBox> {
    const newData = await this.rpc('custom_index', data)

    if (Array.isArray(newData)) this.set(newData)

    return newData
  }
}

const singleton: NineGridBoxes = new NineGridBoxes()

export default singleton
